/*
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced by `pnpm api:build-spec` from apps/api/openapi.root.yaml plus every
 * apps/api/src/**‍/openapi.paths.yaml fragment. Edit a fragment and re-run the build; an
 * edit here is overwritten, and `spec.test.ts` fails while this file and the fragments
 * disagree.
 */
import operationJson from "./operations.json" with { type: "json" };
/**
 * Every operation the API documents, sorted by operationId.
 *
 * The contract test compares this against `apps/api`'s route table in both directions: a
 * route that is served but undocumented, and an operation that is documented but unserved,
 * are both failures.
 *
 * The rows live in `operations.json` for the reason `spec.json` does — see the note in
 * the generator.
 */
export const API_OPERATION = operationJson;
/** Every documented, stable error code, as the spec carries it. */
export const API_ERROR_CODE = [
    "configuration_missing",
    "configuration_invalid",
    "measured_constant_unset",
    "measured_constant_provisional",
    "validation_failed",
    "malformed_e164",
    "malformed_sip_uri",
    "password_too_short",
    "unsupported_media_type",
    "payload_too_large",
    "idempotency_key_reused_with_different_body",
    "cursor_invalid",
    "authentication_required",
    "credential_invalid",
    "auth_session_expired",
    "auth_session_revoked",
    "csrf_token_invalid",
    "mfa_required",
    "mfa_factor_invalid",
    "sso_required_for_domain",
    "api_key_revoked",
    "permission_denied",
    "scope_insufficient",
    "member_role_insufficient",
    "recording_access_denied",
    "recording_operator_access_disabled",
    "impersonation_forbidden",
    "impersonation_expired",
    "operator_read_only",
    "break_glass_required",
    "not_found",
    "voice_agent_not_found",
    "agent_version_not_found",
    "conversation_not_found",
    "channel_binding_not_found",
    "customer_order_not_found",
    "contact_list_not_found",
    "conflict",
    "live_version_seq_stale",
    "slug_taken",
    "address_already_bound",
    "sso_domain_already_claimed",
    "entra_tenant_already_mapped",
    "do_not_call_entry_exists",
    "coupon_already_redeemed",
    "agent_version_not_ready",
    "voice_agent_paused",
    "account_suspended",
    "language_unavailable",
    "language_pack_incomplete",
    "acknowledgement_set_unavailable",
    "voice_does_not_speak_language",
    "extraction_failed",
    "build_failed",
    "connection_operation_not_allowed",
    "connection_secret_unresolvable",
    "tenant_resolution_failed",
    "campaign_window_closed",
    "contact_suppressed",
    "credit_exhausted",
    "trial_exhausted",
    "hard_stop_reached",
    "budget_exceeded",
    "payment_declined",
    "payment_requires_action",
    "payment_requires_reauth",
    "payment_outcome_ambiguous",
    "payment_method_not_found",
    "currency_not_supported",
    "rate_limited",
    "upstream_failed",
    "upstream_timed_out",
    "model_pool_unavailable",
    "speech_provider_failed",
    "carrier_failed",
    "payment_provider_failed",
    "internal_error",
    "audit_write_failed",
    "data_integrity_out_of_range",
    "email_taken",
    "country_unsupported",
    "time_zone_invalid",
    "contact_list_in_use",
    "contact_source_unavailable",
    "contact_source_too_many_rows",
    "campaign_not_found",
    "campaign_state_conflict",
    "campaign_calling_window_invalid",
    "campaign_simultaneous_call_over_ceiling",
    "survey_round_not_found",
    "export_too_large",
    "export_format_unavailable",
    "do_not_call_entry_not_found",
    "retention_option_invalid",
    "person_data_request_term_invalid",
    "optimisation_review_not_found",
    "optimisation_finding_not_found",
    "optimisation_review_state_conflict",
    "optimisation_review_unavailable",
    "return_path_invalid",
    "step_up_required",
    "totp_enrolment_not_started",
    "impersonation_handoff_invalid",
    "agent_runtime_unavailable",
    "idempotency_in_progress",
    "build_already_started",
    "build_no_document",
    "document_too_large",
    "document_type_unsupported",
    "document_count_exceeded",
    "document_mismatch",
    "upload_grant_expired",
    "upload_grant_invalid",
    "number_bound_elsewhere",
    "number_not_held",
    "voice_agent_not_pausable",
    "voice_agent_not_paused",
    "voice_agent_paused_by_operator",
    "voice_agent_archive_refused",
    "voice_agent_archived",
    "rebuild_refused",
    "build_job_not_found",
    "build_in_progress",
    "edit_unchanged",
    "edit_needs_no_build",
    "document_location_mismatch",
    "all_lines_busy",
    "webrtc_unavailable",
    "widget_voice_disabled",
    "widget_voice_unavailable",
    "origin_not_allowed",
    "proof_of_work_failed",
    "origin_invalid",
    "origin_list_empty",
    "person_data_request_not_found",
    "person_data_export_not_ready",
    "person_data_export_expired",
    "customer_order_payment_link_active",
    "customer_order_already_paid",
    "customer_order_not_paid_online",
    "refund_exceeds_paid_amount",
    "refund_decision_required",
    "online_payment_unavailable",
    "payment_link_not_found",
    "payout_destination_invalid",
    "payout_destination_unverified",
    "step_up_unavailable",
    "maker_checker_violation",
    "safeguarding_shortfall",
    "payout_run_open",
    "nothing_to_pay_out",
    "payout_state_conflict",
    "general_live_off",
    "regulatory_sign_off_missing",
    "payout_run_unbuilt",
    "payout_run_building",
    "caller_id_not_bound",
    "destination_refused",
    "sip_trunk_unverified",
    "sip_trunk_disabled",
    "daily_ceiling_reached",
    "sip_edge_unavailable",
    "sip_trunk_in_use",
    "sip_trunk_number_taken",
    "sip_trunk_check_cooldown",
    "sip_trunk_inbound_off",
    "sip_trunk_limit_reached",
    "voice_sample_unavailable",
    "campaign_question_not_accepted",
    "returning_person_unavailable",
    "campaign_not_deletable",
    "scope_required",
    "scope_changed",
    "capability_missing",
    "assurance_required",
    "network_not_allowed",
    "impersonation_scope_fixed",
    "revision_stale",
    "quote_stale",
    "quote_expired",
    "quote_mismatch",
    "operation_conflict",
    "operation_state_conflict",
    "payment_pending",
    "entitlement_exhausted",
    "concurrency_entitlement_reached",
    "seat_limit_reached",
    "resource_limit_reached",
    "allocation_exceeds_grant",
    "allocation_below_use",
    "offer_not_sellable",
    "commercial_policy_unset",
    "custom_offer_policy_unset",
    "retention_policy_unset",
    "terms_revision_unset",
    "tax_policy_unset",
    "tax_rate_unset",
    "account_closing",
    "account_suspended_nonpayment",
    "workspace_draining",
    "workspace_archived",
    "workspace_creation_forbidden",
    "invitation_unavailable",
    "invitation_identity_mismatch",
    "email_unverified",
    "last_owner_protected",
    "owner_change_forbidden",
    "transfer_exceeds_available",
    "payment_method_in_use",
    "mandate_unavailable",
    "auto_reload_limit_reached",
    "refund_not_refundable",
    "legal_profile_required",
    "tax_id_malformed",
    "tax_id_verifier_unconfigured",
    "document_not_issued",
    "sign_in_policy_lockout",
    "sign_in_policy_domain_unverified",
    "last_sign_in_method",
    "mfa_enrolment_required",
    "recovery_code_invalid",
    "sign_in_code_invalid",
    "domain_check_unavailable",
    "suppression_unavailable",
    "share_unavailable",
    "share_revoked",
    "closure_blocked",
    "terms_acceptance_required",
    "operator_approval_required",
    "operator_capability_missing",
    "cost_price_backdate_refused",
    "status_text_refused",
    "probe_signature_invalid",
    "billing_assignment_missing",
    "issuer_unset",
    "vat_rate_backdate_refused",
    "domain_join_offer_unavailable",
    "auth_session_superseded",
    "channel_unit_limit_above_entitlement",
    "name_taken",
    "campaign_started",
    "sip_trunk_inbound_only",
    "forward_destination_refused",
    "forward_unavailable",
    "draft_base_changed",
    "test_call_arm_not_found",
    "survey_question_set_not_ready",
    "agent_version_pinned",
    "signup_limit_reached",
    "agent_build_limit_reached",
    "talk_rate_cutover_pending",
    "talk_rate_start_in_past",
    "talk_rate_change_pending",
    "talk_rate_change_started",
    "talk_rate_unclassified",
    "talk_rate_missing",
    "overage_rate_retired",
    "website_address_refused",
    "website_address_missing",
    "information_input_missing",
    "information_input_too_large",
    "website_reading_in_progress",
    "website_reading_not_found",
    "website_page_not_found",
    "handoff_not_offered",
    "handoff_unavailable",
    "handoff_destination_refused",
    "handoff_language_unavailable",
    "information_index_model_mismatch",
    "help_unavailable",
    "help_unavailable_impersonating",
    "help_grant_refused",
    "help_challenge_invalid",
    "help_rate_limited",
    "help_request_not_found",
    "help_conversation_mismatch",
    "help_takeover_held",
    "help_takeover_not_held",
    "help_state_illegal",
    "help_documentation_building",
    "identity_challenge_invalid",
    "bot_organization_ineligible",
    "subscription_sale_closed",
    "subscription_tax_id_required",
    "subscription_consent_missing",
    "subscription_change_unavailable",
    "offer_scope_ineligible",
    "offer_term_unsupported",
    "payment_method_in_use_by_subscription",
    "subscription_renewal_attempt_ceiling",
    "subscription_renewal_unresolved",
    "subscription_tax_treatment_invalid",
    "pass_target_self",
    "pass_target_not_found",
    "pass_target_archived",
    "pass_target_cannot_receive",
    "pass_source_cannot_pass",
    "pass_target_audience_crossed",
    "pass_target_limit_exceeded",
    "pass_target_duplicate",
    "help_delegation_refused",
    "help_delegation_invalid",
    "help_action_unavailable",
    "help_action_stale",
    "provider_code_invalid",
    "provider_sign_in_expired",
    "provider_code_limit",
    "provider_sign_in_refused",
    "caller_protection_unavailable",
    "blocked_number_limit_reached",
    "block_unavailable",
    "access_list_unavailable",
    "assurance_level_unavailable",
    "access_entry_exists",
    "access_entry_limit_reached",
    "access_list_required",
    "campaign_simultaneous_call_over_voice_agent_limit",
    "campaign_simultaneous_call_over_workspace_limit",
    "not_a_survey",
    "questionnaire_base_stale",
    "questionnaire_invalid",
    "survey_rule_unavailable",
    "survey_fact_in_questionnaire",
    "optimisation_review_already_open",
    "optimisation_finding_not_applicable",
    "party_confirmation_unavailable",
    "capability_not_protectable",
    "method_unavailable",
    "confirmation_code_price_unset",
    "passcode_unavailable",
    "confirmation_code_price_unchanged",
    "confirmation_code_price_in_past",
    "confirmation_code_price_overlap",
    "confirmation_code_price_started",
    "campaign_field_locked",
    "campaign_finished",
    "mobile_surface_refused",
    "app_authorization_code_invalid",
    "app_sign_in_unavailable",
    "app_sign_in_refused",
    "app_push_unavailable"
];
//# sourceMappingURL=operations.js.map